import { number, shape, string } from 'prop-types';

export default shape({
    color: string.isRequired,
    createdAt: number.isRequired,
    id: string.isRequired,
    name: string.isRequired,
});
